import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { UserService } from '@mogenius/user/services/user/user.service';
import { AuthService } from '@mogenius/user/services/auth/auth.service';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Directive({ selector: '[moOnly]', standalone: true })
export class MoOnlyDirective implements OnInit, OnDestroy {
  private readonly _userService = inject(UserService);
  private readonly _templateRef = inject<TemplateRef<any>>(TemplateRef);
  private readonly _viewContainer = inject(ViewContainerRef);
  private readonly _authService = inject(AuthService);

  private _hasView = false;
  private _subscription: Subscription | null = null;

  ngOnInit(): void {
    this._subscription = this._userService.user$
      .pipe(
        filter((user) => user !== null),
        take(1)
      )
      .subscribe((user) => {
        const shouldShow = user?.isMoUser || this._authService.isInCustomerSupportMode;
        this.updateView(shouldShow);
      });
  }

  private updateView(shouldShow: boolean): void {
    if (shouldShow && !this._hasView) {
      this._viewContainer.createEmbeddedView(this._templateRef);
      this._hasView = true;
    } else if (!shouldShow && this._hasView) {
      this._viewContainer.clear();
      this._hasView = false;
    }
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
}
